import { Routes } from '@angular/router';

const title = 'Configuración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'anuncio',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Anuncios' }] },
        loadComponent: () => import('./pages/anuncio-lista/anuncio-lista.component'),
      },
      /* {
        path: 'registro',
        title,
        data: { ...data, urls: [{ url: '/usuario', title: 'Usuario' }, { title: 'Nuevo usuario' }] },
        loadComponent: () => import('./pages/usuario-registro/usuario-registro.component'),
      }, */
    ],
  },
];
